(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('centerAlign', function() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: '/common/centerAlign.html?_hv=f512b82'
    };
  });
})(window, window.angular);
